<div *ngIf="bookingSlot" class="from-time-to-time">
  <span class="hours">{{ getHourString(bookingSlot.fromTime) }}</span><span class="time-divider">:</span><span class="minutes">{{ getMinutesString(bookingSlot.fromTime)
    }}</span> -
  <span class="hours">{{ getHourString(bookingSlot.toTime) }}</span><span class="time-divider">:</span><span class="minutes">{{ getMinutesString(bookingSlot.toTime) }}</span>
</div>
